export default "__VITE_ASSET__CqvMZqIs__"